import { faArrowDown, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SUBHEADING = [
  {
    id: 1,
    subHeading1: "Homepage 1",
    subHeading2: "Homepage 2",
    subHeading3: "Homepage 3",
    to1: "/homepage1",
    to2: "/homepage2",
    to3: "/homepage3",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    id: 2,
    subHeading1: "Action & Adventure",
    subHeading2: "Sports",
    subHeading3: "Kids and Family",
    to1: "/adventure",
    to2: "/sports",
    to3: "/kids",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    id: 3,
    subHeading1: "Blog Left",
    subHeading2: "Blog Right",
    subHeading3: "Blog Full Width",
    subHeading4: "Blog Detail",
    to1: "/blogleft",
    to2: "/blogright",
    to3: "/blogfull",
    to4: "/blogdetail",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    id: 4,
    subHeading1: "Shopping Cart",
    subHeading2: "Product Detail",
    to1: "/cart",
    to2: "/productdetail",
    closeIcon: <FontAwesomeIcon icon={faArrowRight} />,
    downIcon: <FontAwesomeIcon icon={faArrowDown} />,
  },
  {
    id: 5,
    to1: "/about",
    className: "headingDrop",
  },
  {
    id: 6,
    to1: "/contact",
    className: "headingDrop",
  },
];

// export const MAINHEADING = [
//   {
//     id: 1,
//     heading: "Home",
//     subHeading1: "Homepage 1",
//     subHeading2: "Homepage 2",
//     subHeading3: "Homepage 3",
//     subHeading4: "",
//     to1: "/homepage1",
//     to2: "/homepage2",
//     to3: "/homepage3",
//     to4: "",
//     category: "home",
//   },
//   {
//     id: 2,
//     heading: "Game Category",
//     subHeading1: "Action & Adventure",
//     subHeading2: "Sports",
//     subHeading3: "Kids and Family",
//     subHeading4: "",
//     to1: "/adventure",
//     to2: "/sports",
//     to3: "/kids",
//     to4: "",
//     category: "game",
//   },
//   {
//     id: 3,
//     heading: "Blog",
//     subHeading1: "Blog Left",
//     subHeading2: "Blog Right",
//     subHeading3: "Blog Full Width",
//     subHeading4: "Blog Detail",
//     to1: "/blogleft",
//     to2: "/blogright",
//     to3: "/blogfull",
//     to4: "/blogdetail",
//     category: "blog",
//   },
//   {
//     id: 4,
//     heading: "Product",
//     subHeading1: "Shopping Cart",
//     subHeading2: "Product Detail",
//     subheading3: "",
//     subheading4: "",
//     subHeading5: "",
//     subHeading6: "",
//     to1: "/cart",
//     to2: "/productdetail",
//     category: "product",
//   },
//   {
//     id: 5,
//     heading: "About",
//     subHeading1: "",
//     subHeading2: "",
//     subHeading3: "",
//     subHeading4: "",
//     subHeading5: "",
//     subHeading6: "",
//     to1: "/about",
//     category: "about",
//   },
//   {
//     id: 6,
//     heading: "Contact",
//     subHeading1: "",
//     subHeading2: "",
//     subHeading3: "",
//     subHeading4: "",
//     subHeading5: "",
//     subHeading6: "",
//     to1: "/contact",
//     category: "contact",
//   },
// ];
